module.exports = {
      id: "success-icon-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#success-icon",
      toString: function () {
        return this.url;
      }
    }